package org.example.project.service

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

data class ServiceDocumentViewerState(
    val title: String = "",
    val fileName: String = "",
    val blobUrl: String = "",
    val snapshot: YardDocumentSnapshot? = null
)

object ServiceDocumentViewerService {
    var current by mutableStateOf<ServiceDocumentViewerState?>(null)
        private set

    fun show(fileName: String, blobUrl: String) {
        if (blobUrl.isBlank()) return
        current?.blobUrl?.takeIf { it.isNotBlank() }?.let { oldUrl ->
            js("URL.revokeObjectURL(oldUrl)")
        }
        val cleanName = fileName.trim().ifBlank { "dokument.pdf" }
        current = ServiceDocumentViewerState(
            title = cleanName.substringBeforeLast(".").ifBlank { cleanName },
            fileName = cleanName,
            blobUrl = blobUrl
        )
    }

    fun showSnapshot(fileName: String, snapshot: YardDocumentSnapshot) {
        current?.blobUrl?.takeIf { it.isNotBlank() }?.let { oldUrl ->
            js("URL.revokeObjectURL(oldUrl)")
        }
        val cleanName = fileName.trim().ifBlank { "dokument.pdf" }
            .replace(Regex("\\.json$", RegexOption.IGNORE_CASE), ".pdf")
        current = ServiceDocumentViewerState(
            title = cleanName.substringBeforeLast(".").ifBlank { cleanName },
            fileName = cleanName,
            snapshot = snapshot
        )
    }

    fun setRenderedPdf(blobUrl: String) {
        if (blobUrl.isBlank()) return
        val state = current ?: return
        current = state.copy(blobUrl = blobUrl)
    }

    fun close() {
        current?.blobUrl?.takeIf { it.isNotBlank() }?.let { oldUrl ->
            js("URL.revokeObjectURL(oldUrl)")
        }
        current = null
    }
}
